import { Menu, Dropdown } from "antd";
import useStores from "graphql/useStores";
import { useBusinessContext } from "BusinessApp";
import Colors from "assets/Colors";
import ArrowDown from "components/icons/ArrowDown";

import { useTranslation } from "react-i18next";
import s from "./styles";

function StoreSelector() {
  const { t } = useTranslation();
  const businessContext = useBusinessContext();
  const { stores /* , loading */ } = useStores();

  const menu = (
    <Menu style={{ maxHeight: "225px", overflow: "auto", padding: "0px" }}>
      <Menu.Item
        key="empty"
        onClick={() => [
          businessContext.setStoreId(""),
          businessContext.setStoreInfo(""),
        ]}
        style={{
          height: "45px",
          background: !businessContext.storeId && Colors.primary,
          color: !businessContext.storeId && "#fff",
          margin: "8px 8px",
        }}
      >
        {t("containers.SideBarTopMenuHOC.StoreSelector.notSelected")}
      </Menu.Item>
      {stores.map((store) => (
        <Menu.Item
          key={store._id.toString()}
          onClick={() => {
            [
              businessContext.setStoreId(store._id.toString()),
              businessContext.setStoreInfo(store),
            ];
          }}
          style={{
            height: "45px",
            background: businessContext.storeId === store._id && Colors.primary,
            color: businessContext.storeId === store._id && "#fff",
            margin: "8px 8px",
          }}
        >
          {store.address1}
        </Menu.Item>
      ))}
    </Menu>
  );

  const currentStore = stores.find(
    (store) => store._id === businessContext.storeId
  );

  const address = currentStore
    ? currentStore.address1
    : t("containers.SideBarTopMenuHOC.StoreSelector.notSelected");

  return (
    <s.Wrapper onClick={(e) => e.stopPropagation()}>
      <Dropdown overlay={menu} trigger={["click"]}>
        <s.StoreContainer>
          {t("containers.SideBarTopMenuHOC.StoreSelector.location")}: {address}
          <ArrowDown style={{ marginLeft: "11px" }} />
        </s.StoreContainer>
      </Dropdown>
    </s.Wrapper>
  );
}

export default StoreSelector;
